module.exports = __webpack_public_path__ + "static/img/background7.d52bd33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background7.png
// module id = UmLC
// module chunks = 13